export default "__VITE_ASSET__BR7BBTkk__"